import { createApp } from 'vue'
import {createBootstrap} from 'bootstrap-vue-next/plugins/createBootstrap'
import {getElementConfig} from '@/composable/getElementConfig'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import App from './App.vue'
import defaults from './config.js'
// App wird im Element mit der ID glasses-main-app eingeblendet
// const  rootelement =  document.getElementById("glasses-pdp-app");

const attributes = getElementConfig()
//Defaults aus config.js werden von Konfigurationen aus Elementattributen überschrieben
const options = { ...defaults, ...attributes}
// Create APP
const app = createApp(App, {
  config: options
}, options)
app.use(createBootstrap()) // Important
app.mount('#glasses-pdp-app')

